import * as React from "react";
import { ToolbarProps, ToolbarSlot } from "@react-pdf-viewer/toolbar";
import { RotateDirection } from "@react-pdf-viewer/core";

/**
 * Toolbar premium dùng chung cho react-pdf-viewer.
 *
 * Cách dùng:
 *   const defaultLayoutPluginInstance = defaultLayoutPlugin({
 *     renderToolbar: renderPremiumToolbar,
 *   });
 *
 * Giữ nguyên sidebar (thumbnail / bookmark / đính kèm) và toàn bộ chức năng,
 * chỉ sắp xếp lại thanh công cụ theo nhóm rõ ràng: điều hướng · zoom · công cụ.
 * Style nằm trong pdf.component.css (class .pv-toolbar*).
 */
export const renderPremiumToolbar = (
  Toolbar: (props: ToolbarProps) => React.ReactElement
): React.ReactElement => (
  <Toolbar>
    {(slots: ToolbarSlot) => {
      const {
        CurrentPageInput,
        NumberOfPages,
        GoToNextPage,
        GoToPreviousPage,
        ZoomIn,
        ZoomOut,
        Zoom,
        Download,
        Print,
        Rotate,
        EnterFullScreen,
        ShowSearchPopover,
      } = slots;

      return (
        <div className="pv-toolbar">
          <div className="pv-toolbar__group">
            <ShowSearchPopover />
          </div>

          <div className="pv-toolbar__spacer" />

          <div className="pv-toolbar__group">
            <GoToPreviousPage />
            <div className="pv-toolbar__pagebox">
              <CurrentPageInput />
              <span className="pv-toolbar__sep">/</span>
              <NumberOfPages />
            </div>
            <GoToNextPage />

            <span className="pv-toolbar__divider" />

            <ZoomOut />
            <Zoom />
            <ZoomIn />
          </div>

          <div className="pv-toolbar__spacer" />

          <div className="pv-toolbar__group">
            <Rotate direction={RotateDirection.Forward} />
            <Download />
            <Print />
            <EnterFullScreen />
          </div>
        </div>
      );
    }}
  </Toolbar>
);
